import React, { useState, useEffect } from "react";
import goldStar from "../img/goldstar.gif";
import { useApi } from "../apiHelpers";

const GoldStars = () => {
    const [state, setState] = useState({
        recentStars: [],
        isActive: false,
    });

    const api = useApi();

    useEffect(() => {
        const nineDaysAgo = new Date();
        nineDaysAgo.setDate(nineDaysAgo.getDate() - 9);

        let isMounted = true;

        const fetchStars = async () => {
            try {
                const stars = await api.get(`/goldstars`);

                if (isMounted) {
                    if (stars.length === 0) {
                        setState({ recentStars: [], isActive: false });
                    } else {
                        const recentStars = stars.filter((star) => {
                            const starDate = new Date(star.dateissued);
                            return starDate >= nineDaysAgo;
                        });

                        setState({ recentStars, isActive: recentStars.length > 0 });
                    }
                }
            } catch (error) {
                console.error("Error fetching gold stars:", error.message);
            }
        };

        fetchStars();

        return () => {
            isMounted = false;
        };
    }, []);

    const renderStars = (starQty) =>
        Array.from({ length: starQty }).map((_, i) => (
            <img className="goldstar_gif" key={i} src={goldStar} alt="Gold Star" />
        ));

    const renderWinners = () => {
        const { recentStars } = state;

        const winnerMap = recentStars.reduce((acc, { winner, starqty }) => {
            acc[winner] = (acc[winner] || 0) + starqty;
            return acc;
        }, {});

        return Object.entries(winnerMap)
            .reverse()
            .map(([winner, starQty]) => (
                <div key={winner} className="flex items-center justify-center gap-2 py-1">
                    <span className="text-primary font-bold text-sm uppercase tracking-wider">{winner}</span>
                    <span className="flex gap-0.5">{renderStars(starQty)}</span>
                </div>
            ));
    };

    return state.isActive ? (
        <div
            className="relative bg-surface-container-low border border-primary/30 rounded-xl px-4 py-3 overflow-hidden
                       transition-all duration-300"
            style={{ boxShadow: '0 0 30px rgba(255,204,51,0.06), 0 1px 3px rgba(0,0,0,.4)' }}
        >
            <div className="absolute top-0 left-0 right-0 h-[2px] rounded-t-xl"
                 style={{ background: 'linear-gradient(90deg, rgba(255,204,51,0.5) 0%, rgba(255,204,51,0.2) 50%, transparent 100%)' }} />
            {renderWinners()}
        </div>
    ) : null;
};

export default GoldStars;
